export const navAutomotiveMenu = [
  [
    {
      key: 'automotive:1',
      url: 'https://carolinas.aaa.com/automotive/',
      label: 'About AAA Automotive',
    },
    {
      key: 'automotive:2',
      url: 'https://carolinas.aaa.com/automotive/carcare/',
      label: 'AAA Car Care',
    },
    {
      key: 'automotive:3',
      url: 'http://locator.carolinas.aaa.com/?type=carcare',
      label: 'Find a Repair Location',
    },
    {
      key: 'automotive:4',
      url: 'https://carolinas.aaa.com/automotive/carcare/services/',
      label: 'Car Care Services',
    },
    {
      key: 'automotive:5',
      url: 'https://carolinas.aaa.com/automotive/carcare/services/oil-change/',
      label: 'Oil Change Services',
    },
    {
      key: 'automotive:6',
      url: 'https://carolinas.aaa.com/automotive/roadside/',
      label: 'Roadside Assistance',
    },
  ],
  [
    {
      key: 'automotive:7',
      url: 'https://carolinas.aaa.com/insurance/products/auto/',
      label: 'Auto Insurance',
    },
    {
      key: 'automotive:8',
      url: 'https://acg.truecar.com/?referrer_id=ZAAA000027283',
      label: 'AAA Auto Buying',
    },
    {
      key: 'automotive:10',
      url: 'https://carolinas.aaa.com/automotive/battery/',
      label: 'Mobile Battery',
    },
    {
      key: 'automotive:11',
      url: 'https://carolinas.aaa.com/automotive/autoglass/',
      label: 'Auto Glass Repair',
    },
    {
      key: 'automotive:12',
      url: 'https://carolinas.aaa.com/car-wash/',
      label: 'FINS Car Wash',
    },
    {
      key: 'automotive:13',
      url: 'https://carolinas.aaa.com/automotive/aar',
      label: 'AAA Approved Auto Repair',
    },
  ],
];

export const navAutomotivePromo = [
  {
    title: 'AAA Car Care Repair and Maintenance',
    content: 'Visit a AAA Car Care Center.',
    img: '',
    buttonText: 'Reserve Your Appointment Today',
    buttonUrl: 'http://locator.carolinas.aaa.com/?type=carcare',
  },
];
